import { Box } from "@mui/material";
import { Button } from "@pav/pav-products-design-system";

export default function ManualEntryModalButtons({ handleClose, isValid }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--spacing-md)",
      }}
    >
      <Button type="submit" fullWidth disabled={!isValid}>
        Done
      </Button>
      <Button buttonType="tertiary" fullWidth onClick={handleClose}>
        Cancel
      </Button>
    </Box>
  );
}
